module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part"
  }, [_vm._v("The Heart of Darkness")]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('span', [_vm._v("Fairfax, Virginia:"), _c('br'), _vm._v("Monday, November 18, 1991; 10:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-732cb024","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/ch002.vue
// module id = 87
// module chunks = 0